/* Stylesheet */

.simple_select {
  position: relative;

  .item {
    --padding-start: 21px;
    --padding-end: 4px;
    --min-height: 48px;
  }

  .dark {
    --background: var(--ion-gradient-secondary);
    --background-hover: #a3b6d3;
    --background-activated: #a3b6d3;
    --ripple-color: var(--ion-color-dark-ripple);

    .value {
      margin: 0px 0px 0px 4px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--ion-color-text-secondary);
    }

    .icon {
      height: 14px;
      width: 14px;
      color: #abb8cd;
    }
  }
}
